import $ from 'jquery';
window.jQuery = $;
require('ms-signalr-client');

function getSIMITURL() {
    var location = window.location || {host:"sim.dcrgraphs.net"};
    return window.env[location.host];
}

export function initSignalR(callback) {
    const connection = $.hubConnection(getSIMITURL());
    const mainHub = connection.createHubProxy('MainHub');

    mainHub.on('simulationRestarted', function (message) {
        window.location.reload();
    });

    mainHub.on('simulationPaused', function (message) {
    });

    mainHub.on('simulationResumed', function (message) {
    });

    mainHub.on('timeForwarded', function (message) {
        console.log(" Time Forwarded!");
        window.location.reload();
    });
    // atempt connection, and handle errors
    connection.start(() => callback(mainHub))
        .done(function () { console.log('Now connected, connection ID=' + connection.id); })
        .fail(function () { console.log('Could not connect'); });
}